// Get All Work Order Jobs

export const GET_WORK_ORDER_DATA_REQUEST = 'GET_WORK_ORDER_DATA_REQUEST';
export const GET_WORK_ORDER_DATA_SUCCESS = 'GET_WORK_ORDER_DATA_SUCCESS';
export const GET_WORK_ORDER_DATA_FAIL = 'GET_WORK_ORDER_DATA_FAIL';
export const UPDATE_WORK_ORDER_JOB_STATUS = 'UPDATE_WORK_ORDER_JOB_STATUS';

// Update Work Order Items Data

export const UPDATE_WORK_ORDER_REQUEST = 'UPDATE_WORK_ORDER_REQUEST';
export const UPDATE_WORK_ORDER_SUCCESS = 'UPDATE_WORK_ORDER_SUCCESS';
export const UPDATE_WORK_ORDER_JOB_ITEM_STATUS =
  'UPDATE_WORK_ORDER_JOB_ITEM_STATUS';
export const UPDATE_WORK_ORDER_FAIL = 'UPDATE_WORK_ORDER_FAIL';
export const CLEAR_UPDATE_WORK_ORDER = 'CLEAR_UPDATE_WORK_ORDER';

export const REMOVE_AUTHURIZATION_REQUEST = 'REMOVE_AUTHURIZATION_REQUEST';
export const REMOVE_AUTHURIZATION_SUCCESS = 'REMOVE_AUTHURIZATION_SUCCESS';
export const REMOVE_AUTHURIZATION_FAIL = 'REMOVE_AUTHURIZATION_FAIL';
export const CLEAR_REMOVE_WORK_ORDER_AUTHORIZATION_STATES =
  'CLEAR_REMOVE_WORK_ORDER_AUTHORIZATION_STATES';

// Update Work Order Status

export const UPDATE_WORK_ORDER_STATUS_REQUEST =
  'UPDATE_WORK_ORDER_STATUS_REQUEST';
export const UPDATE_WORK_ORDER_STATUS_SUCCESS =
  'UPDATE_WORK_ORDER_STATUS_SUCCESS';
export const UPDATE_WORK_ORDER_STATUS_FAIL = 'UPDATE_WORK_ORDER_STATUS_FAIL';

// clear update work order state
export const CLEAR_UPDATE_WORK_ORDER_STATES = 'CLEAR_UPDATE_WORK_ORDER_STATES';

// Start Stop Job Timer
export const START_STOP_JOB_TIMER_REQUEST = 'START_STOP_JOB_TIMER_REQUEST';
export const START_STOP_JOB_TIMER_SUCCESS = 'START_STOP_JOB_TIMER_SUCCESS';
export const START_STOP_JOB_TIMER_FAIL = 'START_STOP_JOB_TIMER_FAIL';

export const CLEAR_START_STOP_JOB_TIMER_STATES =
  'CLEAR_START_STOP_JOB_TIMER_STATES';
export const UPDATE_LABOR_ITEM_MECHANIC_TIME_SUCCESS =
  'UPDATE_LABOR_ITEM_MECHANIC_TIME_SUCCESS';

// clear work order state
export const CLEAR_WORK_ORDER_STATES = 'CLEAR_WORK_ORDER_STATES';
